import { httPostBlob, httpDeleteWithPayload, httpGet, httpGetBlob, httpPost, httpPut } from '../../data'
import type {
  ICorrectiveAction,
  ICorrectiveActionCommentList,
  ICorrectiveActionContactsData,
  ICorrectiveActionList,
  ICorrectiveActionsDeleted,
  ICorrectiveActionSubmitData,
  ICorrectiveActionUpdateData,
} from '../../../domain/interfaces/ICorrectiveAction'

const correctiveActionsUrl = '/correctiveActions'
const publicCorrectiveActionsUrl = '/public/correctiveActions'
const caCommentsUrl = '/caComments'

// TODO: DOWNLOAD CORRECTIVE ACTION PDF
// export async function correctiveActionsGet(ids: string) {
//   return await httpGetBlob(`${submissionsBaseUrl}/generatePDF/?ids=${ids}`)
// }

export async function getAllCorrectiveActions(queryString: string) {
  return await httpGet<ICorrectiveActionList>(`${correctiveActionsUrl}?${queryString}`, false)
}

export async function getAllCorrectiveActionComments(id: string) {
  return await httpGet<ICorrectiveActionCommentList>(`${caCommentsUrl}/?caId=${id}`, false)
}

export async function getAllPublicCorrectiveActionComments(id: string, hash: string) {
  return await httpGet<ICorrectiveActionCommentList>(
    `${publicCorrectiveActionsUrl}/comments?correctiveActionId=${id}&hash=${hash}`,
    false,
  )
}

export async function getOnePersonsCorrectiveActions(queryString: string) {
  return await httpGet<ICorrectiveActionList>(`${correctiveActionsUrl}/forPerson?${queryString}`, false)
}

export async function getAllOwnedCorrectiveActions(queryString: string) {
  return await httpGet<ICorrectiveActionList>(`${correctiveActionsUrl}/owned/?${queryString}`, false)
}

export async function correctiveActionResolve(id: string, data: { description: string }) {
  return await httpPut<ICorrectiveAction>(`${correctiveActionsUrl}/resolved/${id}`, data, false)
}

// Version 2 CORRECTIVE ACTIONS FUNCTIONALITY
export async function correctiveActionById(id: string) {
  return await httpGet<ICorrectiveAction>(`${correctiveActionsUrl}/${id}`)
}

export async function correctiveActionPublicById(id: string, hash: string) {
  return await httpGet<ICorrectiveAction>(`${publicCorrectiveActionsUrl}?correctiveActionId=${id}&hash=${hash}`)
}

export async function correctiveActionAddComment(id: string, data: ICorrectiveActionSubmitData) {
  return await httpPut<ICorrectiveAction>(`${correctiveActionsUrl}/addComment/${id}`, data)
}

export async function correctiveActionUpdateContacts(id: string, data: ICorrectiveActionContactsData) {
  return await httpPut<ICorrectiveAction>(`${correctiveActionsUrl}/${id}`, data)
}

export async function correctiveActionAddPublicComment(id: string, hash: string, data: ICorrectiveActionSubmitData) {
  return await httpPost<ICorrectiveAction>(
    `${publicCorrectiveActionsUrl}/addComment?correctiveActionId=${id}&hash=${hash}`,
    data,
  )
}

export async function correctiveActionSetPublicToUnderReview(hash: string, data: ICorrectiveActionSubmitData) {
  return await httpPost<ICorrectiveAction>(`${publicCorrectiveActionsUrl}/underReview?hash=${hash}`, data)
}

export async function correctiveActionUpdate(id: string, data: ICorrectiveActionUpdateData) {
  return await httpPut<ICorrectiveAction>(`${correctiveActionsUrl}/${id}`, data)
}

export async function correctiveActionPersonAddComment(id: string, data: ICorrectiveActionSubmitData) {
  return await httpPut<ICorrectiveAction>(`${correctiveActionsUrl}/addComment/forPerson/${id}`, data)
}

export async function correctiveActionSendBack(id: string, data: ICorrectiveActionSubmitData) {
  return await httpPut<ICorrectiveAction>(`${correctiveActionsUrl}/sendBack/${id}`, data)
}

export async function correctiveActionClose(id: string, data: ICorrectiveActionSubmitData) {
  return await httpPut<ICorrectiveAction>(`${correctiveActionsUrl}/close/${id}`, data)
}

export async function correctiveActionPDF(id: string) {
  return await httpGetBlob(`${correctiveActionsUrl}/downloadPdf/${id}`)
}

export async function correctiveActionsPDF(ids: string[]) {
  return await httPostBlob(`${correctiveActionsUrl}/generatePDF`, { ids: ids })
}

// TODO: CHECK URLS WHEN BE API IS READY
export async function deleteCorrectiveAction(correctiveActionId: string) {
  return await httpPut<ICorrectiveAction>(
    // `/correctiveActions/${correctiveActionId}`,
    `/correctiveActions/${correctiveActionId}/archive`,
    {},
    // undefined, //no additional headers
  )
}

export async function deleteCorrectiveActions(correctiveActionIds: string[]) {
  return await httpDeleteWithPayload<ICorrectiveActionsDeleted>('/correctiveActions', { correctiveActionIds })
}
